import { useEffect, useRef, useState } from "react";
import type { OperatorMaterialContext } from "../../../shared/production/operator-materials";
import { productionGateway } from "./production-gateway";

export function useOperatorMaterials(runId:string,terminalCode:string,sessionId:string) {
  const scope=`${terminalCode}:${sessionId}:${runId}`;
  const [state,setState]=useState<{scope:string;value:OperatorMaterialContext|null;error:string|null;loading:boolean}>({scope,value:null,error:null,loading:true});
  const [revision,setRevision]=useState(0);
  const currentScope=useRef(scope); currentScope.current=scope;
  useEffect(()=>{
    const controller=new AbortController();
    setState(current=>({scope,value:current.scope===scope?current.value:null,error:null,loading:true}));
    void productionGateway.operatorMaterials(runId,terminalCode,controller.signal).then(value=>{
      if (!controller.signal.aborted && currentScope.current===scope) setState({scope,value,error:null,loading:false});
    }).catch(error=>{
      if (!controller.signal.aborted && currentScope.current===scope) setState(current=>({...current,scope,loading:false,error:error instanceof Error?error.message:"Reçete ve stoklar okunamadı."}));
    });
    return ()=>controller.abort();
  },[runId,terminalCode,scope,revision]);
  return {...(state.scope===scope?state:{scope,value:null,error:null,loading:true}),refresh:()=>setRevision(value=>value+1)};
}
